import Breadcrumb from "./Breadcrumb";
import "./legal-pages.css";

export default function TermsAndConditions() {
  return (
    <section className="oglitz-legal">
      <div className="oglitz-legal__container">
      <Breadcrumb current="Terms & Conditions" />
        <h1 className="oglitz-legal__title">Terms & Conditions</h1>
        <p className="oglitz-legal__updated">Last updated: 01 January 2026</p>

        <div className="oglitz-legal__content">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the Oglitz Software website and services, you
            agree to comply with and be bound by these Terms & Conditions. If
            you do not agree, please discontinue use immediately.
          </p>

          <h2>2. Services</h2>
          <p>
            Oglitz Software provides custom software development, web and mobile
            application development, UI/UX design, cloud services, and
            technology consulting. Service details are defined in individual
            project agreements.
          </p>

          <h2>3. Intellectual Property</h2>
          <p>
            All content, designs, code, graphics, and materials on this website
            are the intellectual property of Oglitz Software unless otherwise
            stated. Unauthorized use is prohibited.
          </p>

          <h2>4. Client Responsibilities</h2>
          <p>
            Clients are responsible for providing accurate information,
            approvals, and assets required for project execution. Delays caused
            by incomplete inputs may affect timelines.
          </p>

          <h2>5. Payments & Billing</h2>
          <p>
            Payment terms are defined in project agreements. Invoices must be
            paid as per agreed schedules. Late payments may result in service
            suspension.
          </p>

          <h2>6. Confidentiality</h2>
          <p>
            Both parties agree to maintain confidentiality of all business,
            technical, and proprietary information shared during the project.
          </p>

          <h2>7. Limitation of Liability</h2>
          <p>
            Oglitz Software is not liable for indirect, incidental, or
            consequential damages. Liability is limited to the amount paid for
            the service provided.
          </p>

          <h2>8. Termination</h2>
          <p>
            Either party may terminate services with written notice in case of
            breach or non-payment. Completed work must be paid for upon
            termination.
          </p>

          <h2>9. Governing Law</h2>
          <p>These Terms & Conditions are governed by the laws of India.</p>

          <h2>10. Contact</h2>
          <p>
            For any questions, contact us at <strong>info@oglitz.com</strong>.
          </p>
        </div>
      </div>
    </section>
  );
}
